var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BECF",
    d: "M6.019 4.598a.522.522 0 0 1 .715-.06l.051.046 3.183 3.235c.208.211.22.553.037.78l-.046.05-3.183 3.09a.523.523 0 0 1-.766-.032.593.593 0 0 1-.016-.754l.047-.052 2.76-2.682-2.769-2.815a.592.592 0 0 1-.057-.752l.044-.054z"
  })));
}

export default SvgIconChevronRight;